import { createAction } from '@reduxjs/toolkit';

export const requestSavePreference = createAction('preference/savePreference');
export const requestViewAllPreferences = createAction('preference/viewAllPreferences');
export const requestSavePreferences = createAction('preference/savePreferences');
